import { getUrls } from '@shared/utils/config/environment';
import { useQuery } from '@tanstack/react-query';
import useGetUserProfileInfo from '../auth/useGetUserProfileInfo';
export default function useGetAllTimePnL() {
  const {
    userName
  } = useGetUserProfileInfo();
  return useQuery({
    queryKey: ['userPnl'],
    queryFn: async () => {
      var _a;
      const baseUrl = getUrls(process.env.NEXT_PUBLIC_ENV == 'LOCAL' ? 'DEV' : process.env.NEXT_PUBLIC_ENV).INDEXER_URL;
      const pnlPromise = fetch(`${baseUrl}/portfolio/pnl-by-user-name?user=${userName}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      });
      const statsPromise = fetch(`api/db/user-stats`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      });
      const [payload, statsPayload] = await Promise.all([pnlPromise, statsPromise]);
      const pnlData = await payload.json();
      const statsData = await statsPayload.json();
      if (!pnlData || !statsData || pnlData.status !== 'success' || statsData.status !== 'success') {
        return {
          pnlData: null,
          statsData: null
        };
      }
      pnlData['totals']['total_volume'] = (_a = pnlData === null || pnlData === void 0 ? void 0 : pnlData.totals) === null || _a === void 0 ? void 0 : _a.realised_pnl_for_buy_value;
      return {
        pnlData,
        statsData
      };
    },
    refetchInterval: 60 * 1000
  });
}